import * as React from 'react'
import { BaseIconProps } from '../../types'

function SvgPlay({ size = '24', color = '#666', ...props }: BaseIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2zm0 2a8 8 0 100 16 8 8 0 000-16zm-1.875 2.566c.323 0 .638.096.905.276l5.75 3.87a1.635 1.635 0 01.129 2.612l-.13.097-5.749 3.869c-.749.504-1.762.299-2.26-.454a1.635 1.635 0 01-.27-.901V8.197c0-.899.725-1.631 1.625-1.631zm.375 2.33v6.34l4.71-3.17-4.71-3.17z"
        fill={color}
      />
    </svg>
  )
}

export default SvgPlay
